import React, { Component } from 'react';

export default class SelectDropdown extends Component {
  constructor(props) {
    super(props);

    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    let selected = this.props.selected;
    let options = this.props.options;

    return (
      <select name={ this.props.name } onChange={ this.handleOnChange }>
      {options && options.map((option) => {
        return <option key={ option.value } selected={ (selected === option.value) ? 'selected' : '' } value={ option.value }>{ option.label }</option>;
      })}
      </select>
    );
  }
}


// WEBPACK FOOTER //
// ./react_src/Components/SelectDropdown.js